module.exports.tiposSecado = ['Solar','Casa elba','Silo','Parabólico'];
module.exports.tiposFruto = ['Café pergamino','Café verde','Café natural','Café honey','Café trilla húmeda','Cacao','Otro'];